import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { clearIndividualTurnoverFormState } from '../store/slices/volumes-form';
import { useLazyGetIndividualVolumeQuery } from '../store/services';
import VolumesForm from '../../partial/volumes/form';
import { RiskScoreClientTypeEnum } from '../../types';

const IndividualVolumesForm = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const {
    individualClientsRisk: {
      volumes: {
        form: { formValues },
      },
    },
  } = useAppSelector((state) => state);

  const { itemId } = useParams();
  const [getVolume, { isLoading, isFetching }] =
    useLazyGetIndividualVolumeQuery();

  const dispatch = useAppDispatch();

  useEffect(() => {
    setPanelIsOpen(true);

    if (itemId) {
      getVolume(itemId);
    }

    return () => {
      dispatch(clearIndividualTurnoverFormState());
    };
  }, [dispatch, itemId]);

  return (
    <VolumesForm
      isLoading={isLoading || isFetching}
      clientType={RiskScoreClientTypeEnum.INDIVIDUAL}
      panelIsOpen={panelIsOpen}
      setPanelIsOpen={setPanelIsOpen}
      formValues={formValues}
    />
  );
};

export default IndividualVolumesForm;
